import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EventEmitterService } from 'src/app/core/services/event-emitter.service';
import { TokenService } from 'src/app/core/services/token.service';
import { UserService } from 'src/app/core/services/user.service';

import {
    ZtButtonConfig,
    ZtButtonType,
} from 'src/app/shared/components/atoms/zt-button/zt-button.model';
import { ZtLoaderService } from 'src/app/shared/components/molecules/zt-loader/zt-loader.service';

@Component({
    selector: 'zt-header',
    templateUrl: 'zt-header.component.html',
    styleUrls: ['zt-header.component.scss'],
})
export class ZtHeaderComponent {
    homeBtnConfig: ZtButtonConfig = {
        label: 'Home',
    };

    loginBtnConfig: ZtButtonConfig = {
        label: 'Login',
    };

    logoutBtnConfig: ZtButtonConfig = {
        label: 'Logout',
    };

    constructor(
        private userService: UserService,
        private loadingService: ZtLoaderService,
        private tokenService: TokenService,
        private router: Router,
        private eventEmitterService: EventEmitterService
    ) {}

    onHomeListener(): void {
        this.router.navigate(['/']);
    }

    onLoginListener(): void {
        this.router.navigate(['/login']);
    }

    onLogoutListener(): void {
        this.loadingService.showLoader();
        setTimeout(() => {
            this.tokenService.removeToken();
            this.eventEmitterService.getEmitter('onLogout').emit();
            this.router.navigate(['/']);
            this.loadingService.hideLoader();
        }, 250);
    }

    isLoggedIn(): boolean {
        return this.userService.isAuthenticated();
    }

    get ZtButtonType(): typeof ZtButtonType {
        return ZtButtonType;
    }
}
